module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "contenedor-interno"
  }, [_vm._m(0), _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    ref: "busqueda",
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Buscar modulos..."
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.selectFirst($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "data"
  }, [_c('transition-group', {
    staticClass: "contenedor-data",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, _vm._l((_vm.listaFiltrada), function(o, index) {
    return _c('div', {
      key: 'modulo_lookup_' + index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.seleccionarClick(o)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")(o.modulo)))])])
  }), 0), (!_vm.isLoading && _vm.listaFiltrada.length === 0) ? _c('div', {
    staticClass: "info-message"
  }, [_c('span', [_vm._v("No se encontraron coincidencias")])]) : _vm._e(), (_vm.isLoading) ? _c('loading', {
    staticClass: "center-lookup"
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Módulos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d840fb6","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lookups/Actividades_Modulo.vue
// module id = 778
// module chunks = 0